import type {RendererProps} from './exercise-registry';

type Selection={startIndex:number;endIndexExclusive:number};

export function nextContiguousSpanSelection(current:Selection|null,index:number,requiredSpanLength:number):Selection{
 if(!current||current.endIndexExclusive-current.startIndex>=requiredSpanLength)return {startIndex:index,endIndexExclusive:index+1};
 if(index===current.startIndex-1)return {startIndex:index,endIndexExclusive:current.endIndexExclusive};
 if(index===current.endIndexExclusive)return {startIndex:current.startIndex,endIndexExclusive:index+1};
 // A disconnected or repeated tap starts a fresh contiguous span deterministically.
 return {startIndex:index,endIndexExclusive:index+1};
}

export function InlineContiguousSpan({payload,value,disabled,onChange,feedback}:RendererProps){
 const syllables=payload.syllables as {syllableId:string;text:string}[];
 const required=Number(payload.requiredSpanLength);
 const answer=value as {startIndex?:number;endIndexExclusive?:number}|null;
 const selected=typeof answer?.startIndex==='number'&&Number.isInteger(answer.startIndex)&&typeof answer?.endIndexExclusive==='number'&&Number.isInteger(answer.endIndexExclusive)
  ?{startIndex:Number(answer?.startIndex),endIndexExclusive:Number(answer?.endIndexExclusive)}:null;
 const terminal=Boolean(feedback?.isCorrect||feedback?.revealCorrectAnswer);
 const correct=feedback?.revealCorrectAnswer?{
  startIndex:Number(feedback.normalizedResult?.correctStartIndex),
  endIndexExclusive:Number(feedback.normalizedResult?.correctEndIndexExclusive)
 }:feedback?.isCorrect?selected:null;
 const count=selected?selected.endIndexExclusive-selected.startIndex:0;
 return <div className="inline-span-body">
  <div className="inline-span-sentence" role="group" aria-label="Слоги предложения по порядку">
   {syllables.map((syllable,index)=>{
    const active=Boolean(selected&&index>=selected.startIndex&&index<selected.endIndexExclusive);
    const right=Boolean(terminal&&correct&&index>=correct.startIndex&&index<correct.endIndexExclusive);
    const wrong=Boolean(feedback&&!feedback.isCorrect&&active&&!right);
    return <button key={syllable.syllableId} type="button" className={`inline-span-syllable${active?' selected':''}${right?' correct':''}${wrong?' wrong':''}`} aria-label={`Слог ${index+1}: ${syllable.text}`} aria-pressed={active} disabled={disabled} onClick={()=>onChange(nextContiguousSpanSelection(selected,index,required))}>{syllable.text}</button>;
   })}
  </div>
  <p className="inline-span-instruction">Нажмите на {required} соседних слога. Если начнёте в другом месте, выделение начнётся заново.</p>
  <p className="inline-span-count" role="status">{terminal?'Выделен правильный непрерывный фрагмент':`Выбрано ${count} из ${required} слогов`}</p>
 </div>;
}
